import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import UserPortalContainer from '../../containers/UserPortalTableContainer/UserPortalTableContainer';
import UserPortalFilterBar from '../../containers/UserPortalFilterBarContainer/UserPortalFilterBarContainer';
import TopNavbar from '../../components/TopNavBar/TopNavBar';
import UserPortalSideBar from '../../containers/UserSideBarContainer/UserSideBarContainer';
import { PageContainer, ContentContainer } from './UserPortalPage.styles';
import { getUserType, getTeamMemberDefaultRoute } from '../../utils/navigation';

export default function UserPortal() {
  const [tabIndex, setTabIndex] = useState(0);
  const [filters, setFilters] = useState({ search: '', status: '', priority: '', payment_status: '' });
  const navigate = useNavigate();

  useEffect(() => {
    const type = getUserType();
    if (type === 'admin') {
      navigate('/product-management', { replace: true });
    } else if (type === 'team_member') {
      navigate(getTeamMemberDefaultRoute() || '/order-management', { replace: true });
    }
  }, [navigate]);

  return (
    <>
      <TopNavbar onTabChange={setTabIndex} />
      <PageContainer>
        <UserPortalSideBar />
        <ContentContainer>
          <UserPortalFilterBar
            value={filters}
            onChange={(f) => setFilters(prev => ({ ...prev, ...f }))}
          />
          <UserPortalContainer tabIndex={tabIndex} filters={filters} />
        </ContentContainer>
      </PageContainer>
    </>
  );
}
